module.exports = __webpack_public_path__ + "static/img/solutionDetailPic17.ee80ede.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic17.jpg
// module id = ldwb
// module chunks = 1